import { normalizeBoolean } from '@change/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_CAMPAIGN_QR_CODE = createFcmConfig('campaign_qr_code', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
